export enum TipoEmbalagemEnum {
    PacoteCaixa = 1,
    RoloCilindro = 2,
    Envelope = 3
}
